import { Modal } from "../../common/Modal";

type UsersSearchHelpModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const UsersSearchHelpModal = ({
  isOpen,
  onClose,
}: UsersSearchHelpModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Aide à la recherche"
      icon="info-circle"
      maxWidth="lg"
    >
      <div className="space-y-3 text-sm text-default-text">
        <p className="font-oxaniumMedium">
          Règles de base pour la recherche dans les comptes :
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <span className="font-oxaniumMedium">OU</span> : utilisez le
            caractère <code>|</code> entre deux termes (ex :{" "}
            <code>admin|psc</code>).
          </li>
          <li>
            <span className="font-oxaniumMedium">ET explicite</span> : utilisez
            le caractère <code>+</code> (ex : <code>admin+France</code>).
          </li>
          <li>
            <span className="font-oxaniumMedium">Exclusion</span> : préfixez un
            terme avec <code>-</code> (ex : <code>-psc</code> pour exclure les
            PSC).
          </li>
          <li>
            <span className="font-oxaniumMedium">Expression exacte</span> :
            mettez la recherche entre guillemets (ex :{" "}
            <code>"SAS Dupont"</code>).
          </li>
        </ul>

        <p className="font-oxaniumMedium">Champs pris en compte :</p>
        <p>
          Type de compte, entreprise, pays, ville, code postal, nom, prénom,
          email, téléphone, date de création, statut d&apos;activation.
        </p>

        <p className="font-oxaniumMedium">Types de compte possibles :</p>
        <p>
          admin, psc, breeder, breeder_assistant, installer, installer_assistant,
          group, group_assistant.
        </p>

        <p className="font-oxaniumMedium">Export CSV :</p>
        <p>
          Le bouton gris avec l&apos;icône de téléchargement exporte{" "}
          <span className="font-oxaniumMedium">
            uniquement les lignes actuellement filtrées
          </span>{" "}
          au format CSV.
        </p>
      </div>
    </Modal>
  );
};

